import React from 'react';
import remoteController from '../svg/remote-controller.svg';

export const RemoteControllerIcon = () => {
  return <img src={remoteController} alt="remote controller" style={{ padding: '0.375rem' }} />;
};
